function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#A1875A;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M19.4,1.5c0,0-5.3-3.2-9.2-0.3c0,0,3-0.2,6.1,2L19.4,1.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M31.4,6c0,0-0.2-0.4-0.4-0.6c0,0-2.1,2.2-6.4,0.1l-3,1.9c0,0,3.5,1.7,6.5,1C30.8,7.6,31.4,6,31.4,6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M31.4,15.1c0,0-0.2-0.4-0.4-0.6c0,0-2.1,2.2-6.4,0.1l-3,1.9c0,0,3.5,1.7,6.5,1C30.8,16.7,31.4,15.1,31.4,15.1z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M0.1,8.4c0,0-1,4.2,4.4,5.3C9.2,14.6,16.8,9.4,20,7.4s9.2-6.3,11.9-1.8c0,0,0.3-1.5-0.5-2.9 c-0.8-1.3-2.7-2.6-6.1-2.3C23,0.6,19.6,1.8,12.7,6.3S2.5,11.9,0.1,8.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M12.7,21.6c0,0,5.3,3.2,9.2,0.3c0,0-3,0.2-6.1-2L12.7,21.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M0.6,17.1c0,0,0.2,0.4,0.4,0.6c0,0,2.1-2.2,6.4-0.1l3-1.9c0,0-3.5-1.7-6.5-1C1.2,15.5,0.6,17.1,0.6,17.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M0.6,8c0,0,0.2,0.4,0.4,0.6c0,0,2.1-2.2,6.4-0.1l3-1.9c0,0-3.5-1.7-6.5-1C1.2,6.4,0.6,8,0.6,8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M31.9,14.7c0,0,1-4.2-4.4-5.3c-4.7-0.9-12.3,4.3-15.5,6.3s-9.2,6.4-11.9,1.8c0,0-0.3,1.5,0.5,2.9 c0.8,1.3,2.7,2.6,6.1,2.3c2.3-0.2,5.7-1.4,12.6-5.9S29.5,11.1,31.9,14.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M13.3,12.1c0,0,1.9-1,3.5-2.1l1.8,1c-0.2,0.2-2.1,1.2-3.6,2.1L13.3,12.1z"
}));

function SvgFavicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.9 23.1",
    style: {
      enableBackground: "new 0 0 31.9 23.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.b6cd26395a9856b259c3b5d7fca610e3.svg";
export { ForwardRef as ReactComponent };